// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__160PK","buttons":"PendingPaymentAlert_buttons__1smS8"};